import { render, staticRenderFns } from "./MagazineReader.vue?vue&type=template&id=8f632654"
import script from "./MagazineReader.vue?vue&type=script&lang=js"
export * from "./MagazineReader.vue?vue&type=script&lang=js"
import style0 from "./MagazineReader.vue?vue&type=style&index=0&id=8f632654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports